import React from 'react';

import { Container } from './styles';

import CountUpAdapter from '../CountUpAdapter';

import { IconProps } from 'phosphor-react';
import { useTheme } from '../../hooks/theme';

interface ICardMainFeaturesProps {
  icon: React.ComponentType<IconProps>;
  title: string;
  value: number;
}

const CardMainFeatures: React.FC<ICardMainFeaturesProps> = ({ icon: Icon, title, value }) => {
  const {theme} = useTheme();
  
  return (
    <Container>
      <aside>
        <h6>{title}</h6>
        <h4>
          <CountUpAdapter value={value} />
        </h4>
      </aside>
      <main>
        <Icon weight="duotone" color={theme === 'light' ? '#fe157e' : '#79ffb8'} size={140} />
      </main>
    </Container>
  );
}

export default CardMainFeatures;